import React, {  useEffect } from 'react';
import { connect } from 'react-redux';
import { GetAllOpenItemsPayload } from '../../../commonTypes/listing';
import AllOpenItemsTable from '../../../components/AdminReports/OpenItems/AllOpenItemsTable';
import { CommonHeader, ErrorSuccessModal } from '../../../components/commons';
import { OPEN_ITEM_HEADER } from '../../../constant/tableHeadersConstants/openItemsHeadersConst';
import {
  getAllOpenItemsAction,
  resetAllOpenItemsLst,
  resetListingError,
  resetListingSuccess
} from '../../../redux/listing';
import { AllOpenItemsType } from '../../../redux/listing/listingTypes';
import { RootState } from '../../../redux/rootReducers';
import { resetAuthError, resetSession } from '../../../redux/auth';

type AppProps = {
  token: string | null;
  fetching: boolean;
  success: number | null;
  statusCode: number | null;
  error: string | null;
  allOpenItemsList: [] | AllOpenItemsType[];
  history?: any;
  dispatchGetAllOpenItemsAction: (data: GetAllOpenItemsPayload) => void;
  dispatchResetAllOpenItemsListAction: () => void;
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
}

const OpenItemsProgressReports = ({
  fetching,
  token,
  success,
  error,
  allOpenItemsList,
  dispatchGetAllOpenItemsAction,
  dispatchResetAllOpenItemsListAction,
  dispatchResetListingError,
  dispatchResetListingSuccess,
  history,
  dispatchResetSession,
  dispatchResetError,
  statusCode
}: AppProps) => {

  useEffect(() => {
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetAllOpenItemsListAction();
    if (token) {
      dispatchGetAllOpenItemsAction({ token })
    }
  }, []);

  const handleErrorModal = () => {
    if (success === 0) {
        if (statusCode === 401) {
            return (
                <ErrorSuccessModal
                    type="error"
                    isOpen={!!error}
                    title="Error"
                    message="Session Expired. Please Login Again!"
                    buttonText="Logout"
                    onPress={() => dispatchResetSession()}
                    statusCode={statusCode}
                />
            )
        } else if ((!!error && statusCode !== 401)) {
            return (
                <ErrorSuccessModal
                    type="error"
                    isOpen={!!error}
                    title="Error"
                    message={error}
                    buttonText="OK"
                    onPress={() => {
                        dispatchResetError()
                    }}
                />
            )
        }
    }
    return false;
};

  return (
    <>
    <div className='row'>
      <div className="col-md-6">
        <CommonHeader title={`Open Items Progress`} />
      </div>
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
        <div className="header">
            <div className="left-header">
              <div className="heading"> Open Item Progress List</div>
              {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${allOpenItemsList?.length} entries found`}</div>}
            </div>
            </div>
          <AllOpenItemsTable
            fetching={fetching}
            allOpenItemsList={allOpenItemsList}
            headers={OPEN_ITEM_HEADER}
            history={history}
          />
        </div>
      </div>
      {handleErrorModal()}
    </>
  )
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.listing.fetching,
  success: state.listing.success,
  error: state.listing.error,
  allOpenItemsList: state.listing.allOpenItemsList,
  statusCode: state.listing.statusCode
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllOpenItemsAction: (data: GetAllOpenItemsPayload) => dispatch(getAllOpenItemsAction(data)),
  dispatchResetAllOpenItemsListAction: () => dispatch(resetAllOpenItemsLst()),
  dispatchResetListingError: () => dispatch(resetListingError()),
  dispatchResetListingSuccess: () => dispatch(resetListingSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetError: () => dispatch(resetAuthError()),
})

export default connect(mapStateTopProps, mapDispatchToProps)(OpenItemsProgressReports);